import { createAction, props } from '@ngrx/store';
import { PROGRESS_NAME } from '../../../ui/shared/ui/vg-progress/vg-progress.component';

export const setProgressAction = createAction(
    '[Current Progress] set',
    props<{ value: string }>(),
);
